import { useTranslation } from "../../i18n/useTranslation";
import styles from './fixcenter-career-job-offers.module.scss';
import globalStyles from '../../global-styles.module.scss';
import classNames from 'classnames';

const CareerSalesChauffeurJobOffer: React.FC = () => {
    const { t } = useTranslation('translation');
    const getTranslate = (code: string) => {
        return ('CAREER_ITEMS.' + code);
    }
    return (
        <>
            <div className={styles.job_offers_container}>
                <div className={styles.content}>
                    <section className={globalStyles.flex_center_item}>
                        <div>
                            <label
                                dangerouslySetInnerHTML={{__html: getTranslate('HEADER_6')}}
                                className={classNames(globalStyles.flex_center_item, styles.h1)}>
                            </label>
                            <label
                                dangerouslySetInnerHTML={{__html: getTranslate('HEADER_7')}}
                                className={classNames(globalStyles.flex_center_item, globalStyles.mb_5, styles.h1)}>
                            </label>
                        </div>
                    </section>
                    <label
                        dangerouslySetInnerHTML={{__html: getTranslate('HEADER_8')}}
                        className={classNames(globalStyles.float_left_item, styles.h1, globalStyles.underline_text, globalStyles.mb_5)}>
                    </label>
                    <label
                        dangerouslySetInnerHTML={{__html: getTranslate('HEADER_9')}}
                        className={classNames(globalStyles.float_left_item, styles.h2, globalStyles.mb_1)}>
                    </label>
                    <ul>
                        <li><span className={styles.h2}>{getTranslate('LI_1')}</span></li>
                        <li><span className={styles.h2}>{getTranslate('LI_2')}</span></li>
                        <li><span className={styles.h2}>{getTranslate('LI_3')}</span></li>
                        <li><span className={styles.h2}>{getTranslate('LI_4')}</span></li>
                    </ul>
                    <label
                        dangerouslySetInnerHTML={{__html: getTranslate('HEADER_10')}}
                        className={classNames(globalStyles.float_left_item, styles.h2, globalStyles.mb_1)}>
                    </label>
                    <ul>
                        <li><span className={styles.h2}>{getTranslate('LI_5')}</span></li>
                        <li><span className={styles.h2}>{getTranslate('LI_6')}</span></li>
                        <li><span className={styles.h2}>{getTranslate('LI_7')}</span></li>
                        <li><span className={styles.h2}>{getTranslate('LI_8')}</span></li>
                        <li><span className={styles.h2}>{getTranslate('LI_9')}</span></li>
                        <li><span className={styles.h2}>{getTranslate('LI_10')}</span></li>
                    </ul>
                    <label
                        dangerouslySetInnerHTML={{__html: getTranslate('HEADER_11')}}
                        className={classNames(globalStyles.float_left_item, styles.h2, globalStyles.mb_1)}>
                    </label>
                    <section className={globalStyles.flex_center_item}>
                        <div>
                            <label
                                dangerouslySetInnerHTML={{__html: getTranslate('HEADER_12')}}
                                className={classNames(globalStyles.flex_center_item, styles.h1)}>
                            </label>
                            <label
                                dangerouslySetInnerHTML={{__html: getTranslate('HEADER_13')}}
                                className={classNames(globalStyles.flex_center_item, globalStyles.mb_5, styles.h1)}>
                            </label>
                        </div>
                    </section>
                    <label
                        dangerouslySetInnerHTML={{__html: getTranslate('HEADER_14')}}
                        className={classNames(globalStyles.float_left_item, styles.h1, globalStyles.underline_text, globalStyles.mb_5)}>
                    </label>
                    <label
                        dangerouslySetInnerHTML={{__html: getTranslate('HEADER_15')}}
                        className={classNames(globalStyles.float_left_item, styles.h2, globalStyles.mb_1)}>
                    </label>
                    <ul className={globalStyles.mb_5}>
                        <li><span className={styles.h2}>{getTranslate('LI_11')}</span></li>
                        <li><span className={styles.h2}>{getTranslate('LI_12')}</span></li>
                        <li><span className={styles.h2}>{getTranslate('LI_13')}</span></li>
                        <li><span className={styles.h2}>{getTranslate('LI_14')}</span></li>
                        <li><span className={styles.h2}>{getTranslate('LI_15')}</span></li>
                    </ul>
                    <label
                        dangerouslySetInnerHTML={{__html: getTranslate('HEADER_16')}}
                        className={classNames(globalStyles.float_left_item, styles.h1, globalStyles.underline_text, globalStyles.mb_5)}>
                    </label>
                    <label
                        dangerouslySetInnerHTML={{__html: getTranslate('HEADER_17')}}
                        className={classNames(globalStyles.float_left_item, styles.h2, globalStyles.mb_1)}>
                    </label>
                    <ul className={globalStyles.mb_5}>
                        <li><span className={styles.h2}>{getTranslate('LI_16')}</span></li>
                        <li><span className={styles.h2}>{getTranslate('LI_17')}</span></li>
                        <li><span className={styles.h2}>{getTranslate('LI_18')}</span></li>
                        <li><span className={styles.h2}>{getTranslate('LI_19')}</span></li>
                        <li><span className={styles.h2}>{getTranslate('LI_20')}</span></li>
                        <li><span className={styles.h2}>{getTranslate('LI_21')}</span></li>
                        <li><span className={styles.h2}>{getTranslate('LI_22')}</span></li>
                        <li><span className={styles.h2}>{getTranslate('LI_23')}</span></li>
                        <li><span className={styles.h2}>{getTranslate('LI_24')}</span></li>
                    </ul>
                    <label
                        dangerouslySetInnerHTML={{__html: getTranslate('HEADER_18')}}
                        className={classNames(globalStyles.float_left_item, styles.h1, globalStyles.underline_text, globalStyles.mb_5)}>
                    </label>
                    <ul className={globalStyles.mb_5}>
                        <li><span className={styles.h2}>{getTranslate('LI_25')}</span></li>
                        <li><span className={styles.h2}>{getTranslate('LI_26')}</span></li>
                        <li><span className={styles.h2}>{getTranslate('LI_27')}</span></li>
                        <li><span className={styles.h2}>{getTranslate('LI_28')}</span></li>
                        <li><span className={styles.h2}>{getTranslate('LI_29')}</span></li>
                    </ul>
                    <section className={globalStyles.flex_center_item}>
                        <div>
                            <label
                                dangerouslySetInnerHTML={{__html: getTranslate('HEADER_19')}}
                                className={classNames(globalStyles.flex_center_item, styles.h1)}>
                            </label>
                            <label
                                dangerouslySetInnerHTML={{__html: getTranslate('HEADER_20')}}
                                className={classNames(globalStyles.flex_center_item, globalStyles.mb_5, styles.h1)}>
                            </label>
                        </div>
                    </section>
                    <label
                        dangerouslySetInnerHTML={{__html: getTranslate('HEADER_21')}}
                        className={classNames(globalStyles.float_left_item, styles.h2, globalStyles.mb_1)}>
                    </label>
                    <label
                        dangerouslySetInnerHTML={{__html: getTranslate('HEADER_22')}}
                        className={classNames(globalStyles.float_left_item, styles.h2, globalStyles.mb_1)}>
                    </label>
                </div>
            </div>
        </>
    );
};

export default CareerSalesChauffeurJobOffer;